<template>
  <div class="page">
    <div>
      <Headline :size="1">Seite nicht erlaubt</Headline>
      <t-button type="link" :action="back">Zurück</t-button>
    </div>
  </div>
</template>

<script>
import Headline from "@/components/Layout/Headline";
import TButton from "@/components/Layout/Button";
export default {
  name: "Forbidden",
  components: { TButton, Headline },
  methods: {
    back() {
      if (window) {
        window.history.back();
      }
    },
  },
};
</script>

<style scoped>
.page {
  @screen md {
    @apply grid-cols-1;
  }
}
</style>
